define('webshopLandingpagesDetailBodyLandingpageBodyIndexesView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'compositeView',
  'webshopLandingpagesDetailBodyLandingpageBodyIndexView',
  'template!webshopLandingpagesDetailBodyLandingpageBodyIndexesView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  CompositeView,
  IndexView,
  Tpl
) {
  'use strict';

  Module.exports = CompositeView.extend({
    template: Tpl,
    className: 'indexes-view ' + CompositeView.prototype.className,
    childView: IndexView,

    modelEvents: {     
      'change:seoIndexes': 'fetch'
    },

    childViewOptions: function () {
      return {
        landingpage: this.model
      };
    },

    onRender: function () {
      CompositeView.prototype.onRender.apply(this);
      this.fetch();
    },

    fetch: function () {
      this.collection.reset();
      _.each(this.options.webshopConfig.getLanguages(), _.bind(function (language) {
        var model = new Backbone.Model({
          lang: language,
          value: this.model.getIndex(language)
        });
        this.collection.add(model);
      }, this));
    }
  });
});
